<template>
  <div v-if="student?.photoUrl" :class="[sizeClass, 'rounded-full overflow-hidden flex-shrink-0']">
    <img :src="student.photoUrl" alt="" class="w-full h-full object-cover" />
  </div>
  <div
    v-else
    :class="[sizeClass, colorClass, 'rounded-full flex items-center justify-center font-medium text-white flex-shrink-0']"
  >
    <span :class="textSizeClass">{{ getStudentInitials(student) }}</span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { getStudentInitials, type StudentLike } from '@/utils/student'

interface StudentWithPhoto extends StudentLike {
  photoUrl?: string
}

const props = withDefaults(
  defineProps<{
    student?: StudentWithPhoto | null
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
    colorIndex?: number
  }>(),
  {
    student: undefined,
    size: 'md',
    colorIndex: 0,
  }
)

const avatarColors = [
  'bg-blue-500',
  'bg-green-500',
  'bg-purple-500',
  'bg-orange-500',
  'bg-pink-500',
  'bg-teal-500',
  'bg-indigo-500',
  'bg-red-500',
]

const sizeClass = computed(() => {
  const sizes: Record<string, string> = {
    xs: 'w-5 h-5',
    sm: 'w-7 h-7',
    md: 'w-10 h-10',
    lg: 'w-16 h-16',
    xl: 'w-20 h-20',
  }
  return sizes[props.size]
})

const textSizeClass = computed(() => {
  const sizes: Record<string, string> = {
    xs: 'text-[8px]',
    sm: 'text-[10px]',
    md: 'text-sm',
    lg: 'text-xl',
    xl: 'text-2xl',
  }
  return sizes[props.size]
})

const colorClass = computed(() => {
  return avatarColors[props.colorIndex % avatarColors.length]
})
</script>
